import { motion } from "framer-motion"
import React from "react"
import { MainButton, SecondaryButton, TertiaryButton } from "../Buttons"
import { enterCheck } from "./Constants"

const CategoryPicker = ({
	categories,
	disabled,
	questionOfTheDay,
	loadingCategory,
	setLoadingCategory,
	loadQuery,
}) => {
	// Load Category chosen while loadijng
	React.useEffect(() => {
		if (loadingCategory !== null) {
			loadQuery(null, loadingCategory)
			setLoadingCategory(null)
		}
	}, [loadingCategory, loadQuery, setLoadingCategory])

	return (
		<motion.div
			key="CategoryWrapper"
			id="CategoryWrapper"
			animate={{ opacity: 1 }}
			initial={{ opacity: 0 }}
			transition={{
				type: "tween",
				duration: ".25",
			}}
			style={{
				display: "flex",
				alignContent: "center",
				justifyContent: "center",
				flexWrap: "wrap",
				minHeight: "266px",
				maxWidth: "750px",
			}}>
			{Object.keys(categories).map(
				(cat) =>
					!categories[cat].hidden &&
					cat !== "Random" && (
						<MainButton
							disabled={disabled}
							order={categories[cat].order}
							key={cat}
							onClick={() => loadQuery(null, cat)}
							onKeyDown={(event) => loadQuery(event, cat)}
							text={cat}
						/>
					)
			)}
			<SecondaryButton
				disabled={disabled}
				order={998}
				key="Random"
				onClick={() => loadQuery(null, "Random")}
				onKeyDown={(event) => loadQuery(event, "Random")}
				text="I'm Feeling Lucky"
			/>
			<motion.div
				style={{ position: "relative", display: "flex", order: 999 }}
				animate={{ bottom: 0 }}
				initial={{ bottom: "550px" }}
				key="QOTD"
				transition={{
					type: "spring",
					duration: ".5",
					bounce: 0.5,
				}}>
				<TertiaryButton
					disabled={disabled}
					onClick={() => {
						loadQuery(null, "Question of the Day", questionOfTheDay.query)
					}}
					onKeyDown={(event) => {
						if (event && enterCheck(event)) {
							return
						}
						loadQuery(event, "Question of the Day", questionOfTheDay.query)
					}}
					text="Question of the Day"
				/>
			</motion.div>
		</motion.div>
	)
}
export default CategoryPicker
